import { render, staticRenderFns } from "./ConfirmShaming.vue?vue&type=template&id=b63e82ae&"
import script from "./ConfirmShaming.vue?vue&type=script&lang=ts&"
export * from "./ConfirmShaming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports